module.exports = __webpack_public_path__ + "img/streamo-small.b68eb4be.svg";